<div>
	<div class="row-sigef">
		<my-col-input selectFistInput [focusOnInit]="true" [tabindex]="tabindex" [mask]="'#'" [decimals]="0" #DTENro [type]="2" [labelName]="'DTE Número'" [required]="true"></my-col-input>
		<my-col-input [tabindex]="tabindex + 1" [mask]="'n0'" [decimals]="0" #DTECantidad [labelName]="'DTE Cantidad'" [required]="true" [allowCero]="false"></my-col-input>
	</div>
</div>

<my-message-dialog></my-message-dialog>

